import { format, formatDistanceToNow, Locale, parseISO, sub } from 'date-fns'
import * as DateFnsLocale from 'date-fns/locale'
import { Language } from '~/types/api/users'

function to02d(num: number): string {
  return num < 10 ? `0${num}` : `${num}`
}

export const formatDuration = (min?: number, sec?: number) =>
  `${to02d(min ?? 0)}:${to02d(sec ?? 0)}`

export const formatDurationWithUnit = (
  min?: number,
  min_unit?: string,
  sec?: number,
  sec_unit?: string,
) => `${min ?? 0}${min_unit ?? '分'} ${sec ?? 0}${sec_unit ?? '秒'}`

export const formatDate = (
  date?: string | null,
  locale?: Language,
  withWeekday: boolean = false,
) => {
  if (date == null || locale === undefined) return undefined

  const parsedDate = parseISO(date)
  switch (locale) {
    case 'ja':
      return format(parsedDate, withWeekday ? 'yyyy年M月d日（E）' : 'yyyy年M月d日', {
        locale: DateFnsLocale.ja,
      })
    case 'en':
      return format(parsedDate, withWeekday ? 'EEEE, MMMM d, yyyy' : 'MMMM d, yyyy', {
        locale: DateFnsLocale.enUS,
      })
    case 'ko':
      return format(parsedDate, withWeekday ? 'yyyy년 MM월 dd일 (E)' : 'yyyy년 MM월 dd일', {
        locale: DateFnsLocale.ko,
      })
    case 'th':
      return format(parsedDate, withWeekday ? 'd MMMM yyyy (E)' : 'd MMMM yyyy', {
        locale: DateFnsLocale.th,
      })
    case 'id':
      return format(parsedDate, withWeekday ? 'd MMMM yyyy (E)' : 'd MMMM yyyy', {
        locale: DateFnsLocale.id,
      })
    case 'es':
      return format(parsedDate, withWeekday ? "EEEE, d 'de' MMMM 'de' yyyy" : "d 'de' MMMM 'de' yyyy", {
        locale: DateFnsLocale.es,
      })
    default: // 例外のケース
      return undefined
  }
}

const dateFnsLocales: Record<Language, Locale> = {
  ja: DateFnsLocale.ja,
  en: DateFnsLocale.enUS,
  ko: DateFnsLocale.ko,
  th: DateFnsLocale.th,
  id: DateFnsLocale.id,
  es: DateFnsLocale.es,
}

export const formatPostedDate = (postedAt?: string, locale?: Language) => {
  if (postedAt == undefined) return ''
  return formatDistanceToNow(parseISO(postedAt), {
    addSuffix: true,
    locale: dateFnsLocales[locale ?? 'en'],
  })
}

export const format1dayBeforeDate = (dateStr?: string) => {
  if (dateStr == undefined) return
  const date = parseISO(dateStr)
  const dateBefore1day = sub(date, { days: 1 })
  return format(dateBefore1day, 'yyyy-MM-dd')
}

export const formatISO8601Duration = (minutes: number, seconds: number): string => {
  return `PT${minutes}M${seconds}S`
}
